/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPlaceholderAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#9FB3C8">
      <path d="M12.43 24h-.77s-.1-.02-.14-.02c-.38-.04-.77-.06-1.15-.11a11.59 11.59 0 0 1-5.51-2.25c-1.65-1.23-2.9-2.79-3.76-4.66-.54-1.18-.87-2.42-1-3.71-.02-.22-.05-.45-.08-.67v-1.09c0-.03.02-.07.02-.1.04-.41.07-.83.13-1.24.39-2.5 1.47-4.67 3.23-6.49A11.74 11.74 0 0 1 8.86.42C9.73.19 10.63.04 11.53 0c.62-.02 1.24.03 1.86.09 1.27.12 2.48.48 3.64 1.02 1.93.91 3.52 2.24 4.76 3.97 1.17 1.65 1.86 3.48 2.11 5.49.04.29.07.59.1.88v1.09c0 .05-.02.1-.02.16-.07.78-.18 1.54-.38 2.3-.56 2.07-1.57 3.89-3.08 5.42a11.85 11.85 0 0 1-3.97 2.66c-1.07.44-2.19.72-3.35.83-.26.02-.52.05-.78.08l.01.01Zm6.85-4.45c2.75-2.58 4.23-7.07 2.48-11.44-1.74-4.33-6.09-7.16-11.11-6.54-4.93.61-8.86 4.75-9.15 9.76-.12 2.11.34 4.09 1.39 5.92a9.98 9.98 0 0 0 1.69 2.18c.78-2.19 2.16-3.78 4.26-4.7 2.1-.92 4.22-.91 6.29.06 2.06.96 3.43 2.58 4.15 4.76Z" />
      <path d="M11.92 12.77c-1.27.05-2.32-.45-3.19-1.33-.82-.83-1.24-1.84-1.27-3.02-.03-1.17.34-2.19 1.11-3.07.74-.84 1.68-1.35 2.78-1.47 1.82-.19 3.28.49 4.3 2 .55.82.74 1.74.7 2.74-.06 1.64-1.29 3.55-3.51 4.06-.3.07-.62.05-.93.08l.01.01Z" />
    </g>
  </svg>
);

export default SvgPlaceholderAvatar;
